/**
 * @desc 退货
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsMaterialRejectBillRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/createRejectBill`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
